import { Component, OnInit, ChangeDetectorRef, ViewChild, OnDestroy } from '@angular/core';
import WidgetsList from './Widgets';
import { moveItemInArray, CdkDragEnter } from '@angular/cdk/drag-drop';
import { WindowContents } from '../shared/enums/windowContents';
import { Subscription } from 'rxjs';
import { DashboardService } from '../shared/services/dashboard.service';
import { GlobalsService } from '../shared/services/globals.service';
import { DQOIReferenceDataQuery } from '../dqoi/state/dqoi-reference-data.query';
import { AppClaims } from '../shared/models/AppClaims';
import { DispatchData } from '../shared/models/DispatchData';
import { OrderQvComponent } from '../order-qv/order-qv.component';
import { TileLayoutReorderEvent, TileLayoutResizeEvent } from '@progress/kendo-angular-layout';
import { UsersBus } from '../shared/models/UsersBus.model';
import { CmProAuthService } from '@app/core/services';
import { UseCPLoader, ICPLoader } from '../shared/decorators/cploader/cploader-decorator';
import { UseFeatureFlagSet, IFeatureFlagSet } from '../shared/decorators/featureflags/featureflagset-decorator';
import { DispatchQVSettingsInput } from '../shared/models/DispatchQVSettingsInput';

@UseCPLoader()
@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})

@UseFeatureFlagSet()
export class DashboardComponent implements OnInit, OnDestroy {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    compLoader: ICPLoader = this as any;
    @ViewChild('orderQvComponent') public orderQvComponent: OrderQvComponent;
    subscriptions: Subscription[] = [];
    private dashboardSubscriptionsInitialized: boolean = false;

    constructor(private svc_dashboard: DashboardService, private svc_globals: GlobalsService, private cd: ChangeDetectorRef, private qry_rd: DQOIReferenceDataQuery, private authService: CmProAuthService
    ) {

    }

    widgets: any[] = [];
    rights: AppClaims = new AppClaims();

    opened: boolean = false;
    gridData: any[];
    dragged: number;

    public activeChildComp: number;
    public windowData: any = {};
    public showDetails: boolean = false;
    public showWindow: boolean = false;
    public contentTypes = WindowContents;
    public columns: number;
    public isReorderable: boolean = true;

    public showDispatchQV: boolean = false;
    public qvId: any; // = "A24F2DDC-D474-416B-BAAC-4FB24214653B";
    public qvSettings: DispatchQVSettingsInput;
    public showDispatchRefrigQV: boolean = false;
    public refrigQVId: any; // = "A24F2DDC-D474-416B-BAAC-4FB24214653B";
    testData1: any;

    ngOnInit() {
        this.setTitle();
        this.setColumns();
        //start the loader and it will clear once the layout is fetched
        this.compLoader.cpLoader = true;
        this.authService.subscribeToLoginEvents((user: UsersBus) => {
            if (user) {
                this.rights = user.appClaims;
                if (!this.dashboardSubscriptionsInitialized) {
                    this.setupDashboardSubscriptions();
                    this.dashboardSubscriptionsInitialized = true;
                }
                this.gridData = WidgetsList.filter(this.checkRights, this).sort((a, b) => {
                    if (a.widgetName > b.widgetName) {
                        return 1;
                    }
                    if (a.widgetName < b.widgetName) {
                        return -1;
                    }
                    return 0;
                });
            }
        });
    }

    setupDashboardSubscriptions() {
        this.subscriptions.push(this.qry_rd.ensureRefDataIsLoaded(this.svc_globals.companyId).subscribe());

        this.subscriptions.push(this.svc_dashboard.openDQOI$.subscribe(
            targetObj => {
                this.showDetailsPopup(targetObj);
            }));
        this.subscriptions.push(this.svc_dashboard.widgetsChanged$.subscribe(
            widgets => {
                this.widgets = widgets.filter(this.checkRights, this).sort();
            }));
        this.subscriptions.push(this.svc_dashboard.openDispatchQV$.subscribe(
            qvId => {
                this.qvId = qvId;
            }));
        this.subscriptions.push(this.svc_dashboard.openDispatchQVSettings$.subscribe(
            settings => {
                //alert(JSON.stringify(settings));
                this.qvSettings = settings;
            }));
        this.subscriptions.push(this.svc_dashboard.openOrderQV$.subscribe(
            order => {
                this.orderQvComponent.SetValue(order);
            }));
        this.subscriptions.push(this.svc_dashboard.openDispatchRefrigQV$.subscribe(
            refrigQVId => {
                this.refrigQVId = refrigQVId;
            }));
    }

    ngOnDestroy() {
        this.subscriptions.forEach(subscription => subscription.unsubscribe());
        this.svc_globals.setTitle('');
        this.authService.unsubscribeToLoginEvents();
    }

    setTitle() {
        this.svc_globals.setTitle('Dashboard');
    }

    toggleGhostWidget(toggleState) {
        this.opened = toggleState;
    }

    changeWidgetLayout(id) {
        if (id && id != '00000000-0000-0000-0000-000000000000') {
            this.compLoader.cpLoader = true;
            this.svc_dashboard.GetDashboardLayout(id).subscribe(
                {
                    next:
                        data => {
                            this.compLoader.cpLoader = false;
                            if (data) {
                                let unfilteredWidgets = JSON.parse(data.layout);
                                unfilteredWidgets = this.setWidgetDefaultFilters(unfilteredWidgets);
                                this.widgets = unfilteredWidgets.filter(this.checkRights, this);
                            }
                        },
                    error: e => {
                        console.error(e);
                        this.compLoader.cpLoader = false;
                        this.svc_globals.notifyError("Unable to load your dashboard layout. If problem persists contact support.", true);
                    }
                });
        } else {
            this.widgets = [];
            this.compLoader.cpLoader = false;
        }
    }

    setWidgetDefaultFilters(widgets: any) {

        if (widgets) {
            widgets.forEach((widget) => {
                widget = this.setWidgetDefaultFilter(widget);
            });
        }
        return widgets;
    }

    setWidgetDefaultFilter(widget: any) {

        if (widget) {

            //MonthEndDrawRecost
            if (widget.widgetId == "CBB135F5-BE58-42C2-987C-BF1A8F87B703") {
                if (!widget.searchParams) {
                    widget.searchParams = {};
                }
                if (widget.searchParams && !widget.searchParams.invoiceStatuses) {
                    widget.searchParams.invoiceStatuses = [];
                    widget.searchParams.invoiceStatuses.push("d4f5dbbe-690e-454d-8b9c-392e69845930");
                }
            }
            // Handle existing Widget layouts where rowColSpan wasn't saved
            if (!widget.rowColSpan) {
                switch (widget.widgetId) {
                    case 'EE6F4ACE-B8EA-440D-B6C7-C7E111956F2F':
                    case '44C61ABA-7768-4031-A924-57F0960B5018':
                        // single sized widgets
                        widget.rowColSpan = { rowSpan: 1, colSpan: 1 };
                        break;
                    default:
                        // default to full size (2)
                        widget.rowColSpan = { rowSpan: 1, colSpan: 1 };
                }
            }
        }
        return widget;
    }

    addWidget({ dataItem, rowIndex, columnIndex }: any) {
        let newItem = JSON.parse(JSON.stringify(dataItem));
        newItem = this.setWidgetDefaultFilter(newItem);
        newItem.position = this.widgets.length ? this.widgets.length : 0;
        this.widgets.push(newItem);
    }

    checkRights(widget: any) {
        switch (widget.widgetId) {
            case 'C7921D2C-B8B7-4B89-87B7-956FF0DEB398':    //Application Help
                return true;
            case '8424A830-B96F-4BEE-BA8C-C11A8C859E5D':	//Fieldgetics News
                return true;
            case '89772690-4040-473F-9431-B6EC683FC68D':	//Dispatch Equipment History
                if (this.rights.DispatchEquipmentHistory) { return true; } else { return false; }
            case 'EE6F4ACE-B8EA-440D-B6C7-C7E111956F2F':	//Dispatch Status Gauge
                if (this.rights.DispatchStatusGauge) { return true; } else { return false; }
            case 'BE10C991-25DE-468F-B784-AEC946613AAE':	//Open Contracts
                if (this.rights.OpenContracts) { return true; } else { return false; }
            case '7F2A3B4C-5D6E-4F70-8901-23456789ABCD':	//Pending Change Orders
                return true;
            case '0C194118-A2EA-4EC0-95D3-B26E6B7C071D':	//Open Dispatches
                return true;
            case '603A6989-5C99-4EF1-8061-2D34A870F0CC':	//Dispatch Review Lite
                return true;
            case '4F98BB3D-B587-45A2-8672-0863F6A0B75A':	//Order Review Lite
                return true;
            case '44C61ABA-7768-4031-A924-57F0960B5018':	//Dispatch Refrigerant Tracking
                return true;
            case '15EBD17B-90E2-4BA3-8927-625E380001D0':	//Active Invoice Dispute
                if (this.rights.ActiveInvoiceDispute) { return true; } else { return false; }
            case 'FD0599A4-3504-41F3-825E-A1823B5C1ACC':	//Credit Memo Approval
                if (this.rights.CreditMemoApproval) { return true; } else { return false; }
            case '3A19E42D-A5E3-4251-A4A6-256B42EF0C3B':	//Open Quotes
                if (this.rights.OpenQuotes) { return true; } else { return false; }
            case 'E898452A-4252-4386-BEC9-0A54999ABC47':	//Quotes Pending Approval
                if (this.rights.QuotesPendingApproval) { return true; } else { return false; }
            case '8A66E5BD-ECC0-4E8B-B241-06730F99D86F':	//Quote Summary
                if (this.rights.QuoteSummary) { return true; } else { return false; }
            case '09AC7ED0-E9E0-4767-A20A-C5BE1ACEF82E':	//Open Vendor Returns
                if (this.rights.OpenVendorReturns) { return true; } else { return false; }
            case '42D75994-2C01-4501-8851-0A9AC607F305':	//Purchase Order Summary
                if (this.rights.PurchaseOrderSummary) { return true; } else { return false; }
            case '2DCCC829-6B7C-45A2-854A-04EB473EE648':	//Zero Dollar Orders
                if (this.rights.ZeroDollarOrders) { return true; } else { return false; }
            case '21C269B7-E19C-404E-A5D3-BAADABB22BAF':	//Invoice Approval
                if (this.rights.InvoiceNeedsApproval) { return true; } else { return false; }
            case 'CBB135F5-BE58-42C2-987C-BF1A8F87B703':	//Construction Month End Draw Re-Cost'
                if (this.rights.MonthEndDrawRecost  && !this.compFeatureFlagSet.featureFlagSet['ui-hide-zuggit-menu-items-extended']) { return true; } else { return false; }
            case '560ABA99-0C32-4C8E-8792-E952757E6896':	//Invoice Sales Summary
                if (this.rights.InvoiceSalesSummary) { return true; } else { return false; }
            case '10DA21A9-4FE2-43B2-97FB-05CAB77F483C':	//Monthly Invoice Sales Detail
                if (this.rights.MonthlyInvoiceSalesDetail) { return true; } else { return false; }
            case '41C4D43D-73DB-43C2-BF0B-4E402163CD3B':	//Tech Hours Summary
                if (this.rights.TechHours && !this.compFeatureFlagSet.featureFlagSet['ui-hide-zuggit-menu-items-extended']) { return true; } else { return false; }
            case 'CFFE2637-F934-4B4F-978F-F3DEE14A7ADF':	//Tech Stat Summary
                if (this.rights.TechStatSummary && !this.compFeatureFlagSet.featureFlagSet['ui-hide-zuggit-menu-items-extended']) { return true; } else { return false; }
            case '22DDD1C4-688B-4911-9DAC-CF21568A2889':	//Account Receivables Summary
                if (this.rights.AccountReceivableSummary) { return true; } else { return false; }
            case '2475BB0F-D0C0-455A-8267-F2E2D015779F':	//Show Customer Statistics
                if (this.rights.CustomerStatistics) { return true; } else { return false; }
            case 'E8603350-9C84-4601-B829-CEB2B3CD4B31':
                if (this.rights.ViewZuggitCPWidget && this.svc_globals.user.isZuggitUser) { return true; } else { return false; }
            default:
                return false;
        }
    }

    reIndexWidgets() {
        this.widgets.forEach((widget, index) => widget.position = index);
    }

    setSearchParams(event) {
        if (event.widgetIndex >= 0 && this.widgets && this.widgets[event.widgetIndex]) {
            this.widgets[event.widgetIndex].searchParams = event.searchParams;
        }

    }

    closeWidget(index: number) {
        this.widgets.splice(index, 1);
        this.cd.detectChanges();
    }

    expandWidget(e) {
        this.widgets[e.index].size = e.size;
        if (this.widgets[e.index].rowColSpan.colSpan == 2) {
            this.widgets[e.index].rowColSpan.colSpan = 1;
        } else {
            this.widgets[e.index].rowColSpan.colSpan = 2;
        }
    }

    minimizeWidget(e) {
        this.widgets[e.index].minimized = e.minimized;
    }

    fullscreenWidget(e) {
        this.widgets[e.index].fullscreen = e.fullscreen;
    }

    nameEditedEvent(e) {
        this.widgets[e.index].widgetName = e.title;
    }

    onChildOutput(event) {
        this.widgets.splice(JSON.parse(event).target, 1);
    }

    entered(event: CdkDragEnter) {
        moveItemInArray(this.widgets, event.item.data, event.container.data);
    }

    dragging(item: number) {
        this.dragged = item;
    }

    dragStop() {
        this.reIndexWidgets();
        this.dragged = null;
    }

    onReorder(e: TileLayoutReorderEvent): void {
        this.testData1 = e.items;
    }

    onTileResize(e: TileLayoutResizeEvent): void {
        this.widgets[e.item.order].rowColSpan.rowSpan = e.newRowSpan;
        this.widgets[e.item.order].rowColSpan.colSpan = e.newColSpan;
    }

    sizeChange(size: number) {
        if (this.dragged != null) {
            this.widgets[this.dragged].size = size;
        }
    }

    showDetailsPopup(targetObj: DispatchData) {
        this.activeChildComp = this.contentTypes.viewDispatch;
        this.windowData = targetObj;
        this.showDetails = true;
    }

    onClosed() {
        this.showDetails = false;
        this.svc_dashboard.dispQVClosed();
    }

    generalWidgetClosed() {
        this.showDetails = false;
        this.svc_dashboard.generalWidgetClosed();
    }

    showDispQVWindow(state: boolean, dispatchId: string) {
        this.cd.detectChanges();
        this.showDispatchQV = state;
        this.qvId = dispatchId;
    }

    DispQVClosed(e: any) {
        this.qvId = null;
        this.svc_dashboard.dispQVClosed();
    }

    showDispRefrigQVWindow(state: boolean, dispatchId: string) {
        this.cd.detectChanges();
        this.showDispatchRefrigQV = state;
        this.refrigQVId = dispatchId;
    }

    DispRefrigQVClosed(e: any) {
        this.refrigQVId = null;
        this.svc_dashboard.dispQVClosed();
    }

    setColumns() {
        if (window.innerWidth <= 1024) {
            this.columns = 1;
        } else {
            this.columns = 2;
        }
    }

    setColumn(index) {
        let columnPosition: number;
        if (window.innerWidth <= 1024) {
            columnPosition = 1;
        } else {
            if ((Number(index) % 2)) {
                columnPosition = 1;
            } else {
                columnPosition = 2;
            }
        }
        return columnPosition;
    }

    public canDrag(event: any) {
        this.isReorderable = event;
    }
}
